// frete.js: frete por CEP na PDP (snippets/frete-cep) e no drawer e em /cart (snippets/frete-carrinho, L10c). Módulo
// sob demanda; teto de 7 KiB (7.168 B) minificado (decisão do JARVIS de 2026-10-17: fora do caminho do LCP, 30 KB por página).
// Contrato v4: hub/frete-proxy/CONTRATO.md (fonte Frenet, v1b; peso real e valor declarado efetivo, L10g) — POST text/plain, sem cookies, resposta em centavos; qualquer status sem JSON
// = "não foi possível calcular agora". Cada consulta tem número: resposta de consulta antiga é descartada (troca de
// variante ou de CEP). Prazo de 8 s (o serviço desiste da Frenet em 6 s). No máximo 1 cotação a cada 3 s na página.
// CEP lembrado na sessão (sessionStorage, o mesmo na PDP e no carrinho) e recalculado ao abrir outra PDP ou o carrinho.
// Exibição da copy 10f (Econômico / Expresso). F-11/F-12/FR-05 (carrinho + esta peça) só quando o snippet tem limiar
// (texto de frete ligado), pela fórmula da Yampi (ver carrinhoMaisPeca); no carrinho, pelo total que o Liquid já traz.
// A PDP inicia ao carregar; o <details> do carrinho, ao abrir (o core.js importa este módulo e chama iniciar).
// L10a-r2-1 / L10a-r4-1 (Riff): próxima cotação permitida na PÁGINA (PDP e drawer juntos) = instante do último envio
// efetivo + intervalo. Quem acorda confere de novo antes de enviar, então duas calculadoras nunca disparam juntas.
let proxima = 0;
// L10c-1 (Riff): só a consulta iniciada por último grava o CEP na sessão; instâncias que saíram do DOM (o cart.js troca
// o corpo do drawer) são canceladas e não fazem POST, não aplicam resultado e não gravam nada.
let escolha = 0;
const vivas = new Map();
let gavetaAberta = false;
// o cart.js troca o corpo do drawer a cada mudança: a calculadora aberta reabre (e recalcula com o carrinho novo)
document.addEventListener('cr:cart:html', () => setTimeout(() => {
  for (const [r, cancela] of vivas) if (!r.isConnected) { cancela(); vivas.delete(r); }
  const d = document.querySelector('details[data-cr-frete]:not([data-pronto])'); if (d && gavetaAberta) d.open = true;
}));
for (const r of document.querySelectorAll('[data-cr-frete]:not(details)')) iniciar(r);

export function iniciar(raiz) {
  if (raiz.dataset.pronto) return;
  raiz.dataset.pronto = 1;
  const carrinho = raiz.dataset.modo === 'carrinho';
  if (carrinho) { gavetaAberta = true; raiz.addEventListener('toggle', () => { gavetaAberta = raiz.open; }); }
  const dados = JSON.parse(raiz.querySelector('[data-cr-frete-dados]')?.textContent || '{}');
  const T = dados.textos || {};
  const variantes = dados.variantes || {};
  const endpoint = raiz.dataset.endpoint;
  const limiar = Number(raiz.dataset.limiar) || 0;
  const pct = Number(raiz.dataset.pct) || 0;
  const k = Number(raiz.dataset.k) || 3;
  const elegPeca = raiz.dataset.eleg === '1';
  const form = raiz.querySelector('form');
  const campo = raiz.querySelector('input[name="cep"]');
  const botao = raiz.querySelector('button');
  const status = raiz.querySelector('.cr-frete__status');
  const lista = raiz.querySelector('.cr-frete__lista');
  const nota = raiz.querySelector('.cr-frete__nota');
  const notaP = raiz.querySelector('[data-cr-frete-nota]');
  const linhaCarrinho = raiz.querySelector('[data-cr-frete-carrinho]');
  // LM-F que acompanha a linha "Frete grátis": no carrinho, sempre; na PDP, só com o texto de frete desligado (ligado, a
  // LM-F fixa já está à vista). Condição A do Gancho no L10l
  const lmf = raiz.querySelector('[data-cr-frete-lmf]');
  const semL = raiz.querySelector('[data-cr-frete-semloggi]'); // FR-09 (L10l)
  const pdp = carrinho ? null : document.getElementById('cr-pdp-form');
  const intervalo = raiz.dataset.intervalo ? Number(raiz.dataset.intervalo) : 3000;
  const CHAVE = 'cr_frete_cep';
  let seq = 0;
  let refaz = null; // recotação agendada por mudança de carrinho (B4); cancelar() a desfaz
  // estado da última lista (L10l): sem opções, sem a Loggi (FR-09) e Loggi grátis pela fonte. limpar() zera; mostrar()
  // define antes de qualquer retorno (L10l-1, Riff): a projeção F-11/F-12 nunca herda o estado da consulta anterior
  let semOp = true, semLoggi = false, gratisL = false;
  let ctl = null;
  let ultimo = '';
  let ultimaVariante = '';

  const digitos = (v) => (v || '').replace(/\D/g, '').slice(0, 8);
  const mascara = (v) => { const d = digitos(v); return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d; };
  const moeda = (c) => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const varianteAtual = () => (pdp?.querySelector('input[name="id"]:checked') || pdp?.querySelector('input[type="hidden"][name="id"]'))?.value || '';
  // a PDP não tem campo de quantidade: a cotação é de 1 peça. Se um campo entrar, ler aqui e escutar input/change.

  // nos: <template> cujo conteúdo vai para a região viva (frase com link: snippets/frete-sem-opcoes, AUD-J)
  function aviso(txt, erro, nos) { if (nos) status.replaceChildren(nos.content.cloneNode(true)); else status.textContent = txt || ''; status.classList.toggle('is-erro', !!erro); status.classList.remove('visually-hidden'); }
  function limpar() { semOp = true; semLoggi = gratisL = false; lista.hidden = true; lista.replaceChildren(); nota.hidden = true; if (semL) semL.hidden = true; if (linhaCarrinho) linhaCarrinho.hidden = true; lmf?.setAttribute('hidden', ''); }
  // L10k-1 (Riff): cancelar desfaz também a recotação agendada (CEP editado, variante trocada, cotação nova)
  function cancelar() { seq += 1; ctl?.abort(); ctl = null; clearTimeout(refaz); refaz = null; botao.disabled = false; return seq; }
  vivas.set(raiz, cancelar);

  // copy 10f (decisão de Henrique, 15/10): no máximo duas linhas, rótulos do tema (o nome da transportadora não aparece).
  // Econômico = a mais barata (empate: menor prazo), destacada. Expresso = a mais rápida, só se tiver prazo menor que a
  // econômica. prazo_dias null (fonte não informou) mostra "prazo no checkout" (FR-06; ajuste B do Gancho no L10a).
  const dias = (o) => (Number.isInteger(o.prazo_dias) ? o.prazo_dias : Infinity);
  // AUD-G3 (L10w): dias somados só no prazo exibido (e no aria, que lê o texto); dias() compara o prazo cru
  // shortcut: 1 é o manuseio da Yampi até o Hub devolver prazo_adicional_dias (v4.1); depois vale o da resposta
  let adic;
  // span com classe e texto (nome, prazo e valor da linha)
  const span = (c, t) => Object.assign(document.createElement('span'), { className: c, textContent: t });
  // FR-05 (L10l): a linha grátis leva o nome do serviço (Loggi Econômico) antes do prazo e fica sem valor
  function linha(rotulo, o, destaque, gratis) {
    const li = document.createElement('li'); li.className = `cr-frete__item${destaque ? ' is-destaque' : ''}`;
    const esq = document.createElement('span');
    const n = o.prazo_dias + adic; // L10w rev. 2 (Fiscal): 0 + 0 também é "até 1 dia útil", nunca "até 0 dias"
    esq.append(span('cr-frete__nome', rotulo), span('cr-frete__prazo', (gratis ? `${T.loggi} · ` : '') + (dias(o) === Infinity ? T.prazoCheckout : n <= 1 ? T.prazo1 : (T.prazoN || '').replace('NNN', n))));
    li.append(esq, span('cr-frete__valor', gratis ? '' : moeda(o.valor))); lista.append(li);
  }
  // FR-07: a região viva lê as linhas inteiras, do estado ATUAL da lista (também depois do FR-05 entrar ou sair);
  // o texto fica só para leitor de tela (a lista já está na tela). Sem anúncio repetido se nada mudou.
  function anunciar() {
    const sel = (li, c) => li.querySelector(c).textContent;
    const txt = `${(T.aria || '').replace('CCC', mascara(ultimo))} ${[...lista.children].map((li) => [sel(li, '.cr-frete__nome'), sel(li, '.cr-frete__valor'), sel(li, '.cr-frete__prazo')].filter(Boolean).join(', ')).join('; ')}.`;
    if (status.textContent !== txt) aviso(txt);
    status.classList.add('visually-hidden');
  }

  // L10l (AUD-H; copy 10j FR-05/FR-09): quem zera é a regra da conta Frenet (a mesma da Yampi), só na Loggi Econômico. O
  // tema não decide gratuidade: "Frete grátis" só na linha da Loggi Econômico que a fonte devolve com valor 0 (nunca
  // pela comparação com o limiar, nunca "a mais barata"). Sem a Loggi na resposta, com texto de frete ligado: FR-09.
  const loggi = (o) => /loggi/i.test(`${o.transportadora} ${o.servico}`) && /econ/i.test(o.servico);
  function mostrar(opcoes) {
    limpar(); // estado zerado: sem opções = sem FR-09 ("opções abaixo") e sem projeção
    if (!opcoes.length) { aviso(T.semOpcoes, 0, raiz.querySelector('[data-cr-frete-semop]')); return; }
    semOp = false;
    // a Loggi Econômico a R$ 0 é a econômica mesmo empatada com outra a R$ 0 (nome e prazo da que é grátis de fato)
    const zero = opcoes.find((o) => o.valor === 0 && loggi(o));
    const eco = zero || opcoes.reduce((a, o) => (o.valor < a.valor || (o.valor === a.valor && dias(o) < dias(a)) ? o : a));
    const exp = opcoes.reduce((a, o) => (dias(o) < dias(a) || (dias(o) === dias(a) && o.valor < a.valor) ? o : a));
    gratisL = !!zero;
    linha(gratisL ? T.gratis : T.eco, eco, true, gratisL);
    if (dias(exp) < dias(eco)) linha(T.exp, exp);
    semLoggi = !!semL && !opcoes.some(loggi); // o FR-09 só existe no HTML com o texto de frete ligado
    if (semLoggi) semL.hidden = false;
    lmf?.toggleAttribute('hidden', !gratisL);
    lista.hidden = false; nota.hidden = false;
    anunciar();
  }

  // F-11 / F-12 / FR-05 (L10a): carrinho atual + esta peça pela fórmula da Yampi, a mesma de snippets/trio-totais e da
  // barra do drawer (nunca cart.total_price com o trio). Lê n, Σ cheios elegíveis e não elegíveis do contêiner da barra
  // (data-kit-n, data-sub, data-fora) na seção do drawer pela Section Rendering API (o drawer só existe depois de aberto).
  // Esta peça entra pelo preço cheio. Com o trio formado (n ≥ k): total = arred(Σ elegíveis × (1 − pct/100)) + não
  // elegíveis; sem trio, a soma simples. Limiar = setting (o mesmo da barra), não o gratis_acima do endpoint: a
  // calculadora nunca contradiz a barra. Enquanto a Yampi cobrar a partir de 299, o bloqueio de publicação B-249 impede
  // que a promessa de 249 chegue ao cliente.
  // No v4 (L10g) a projeção usa SÓ a seção lida para a própria cotação (doc): mesma base do valor e da nota. Não relê a
  // seção por fora (L10g-r3-1) e é refeita junto com a cotação quando o carrinho muda (geração, abaixo). Sem os dados da
  // barra: sem a linha (nada fica prometido sem base). O "Frete grátis" da lista vem só da fonte (L10l, mostrar).
  // seção do drawer pela Section Rendering API
  async function secao(signal) {
    // a casca do drawer (sections/carrinho-gaveta); [data-secao] sozinho pega a seção da PDP (SRA do produto)
    const sec = document.querySelector('[data-cr-gaveta]')?.dataset.secao || 'carrinho-corpo';
    const r = await fetch(`${location.pathname}?sections=${sec}`, { signal });
    return r.ok ? new DOMParser().parseFromString((await r.json())[sec] || '', 'text/html') : null;
  }
  // total efetivo do carrinho + esta peça pela fórmula da Yampi; null sem os dados da barra
  function totalCom(doc, v, qtd) {
    const d = doc?.querySelector('[data-cr-trio]')?.dataset;
    if (!d || d.sub === undefined) return null;
    const peca = v.valor * qtd;
    const n = Number(d.kitN) + (elegPeca ? qtd : 0), sub = Number(d.sub) + (elegPeca ? peca : 0), fora = Number(d.fora) + (elegPeca ? 0 : peca);
    return n >= k ? Math.round(sub * ((100 - pct) / 100)) + fora : sub + fora;
  }
  function carrinhoMaisPeca(doc, v, qtd) {
    if (!limiar || !linhaCarrinho) return;
    const total = totalCom(doc, v, qtd);
    const chegou = total !== null && total >= limiar;
    linhaCarrinho.textContent = total === null ? '' : chegou ? T.chegou : (T.falta || '').replace('FFF', moeda(limiar - total));
    // L10l: F-11/F-12 seguem a barra (limiar do setting). O "Frete grátis" da lista é só o da fonte (mostrar). Somem:
    // sem opções (L10l-1: nada a prometer), CEP sem a Loggi (o FR-09 explica; copy 10j, E2/F-12) e "faltam" com a Loggi
    // já grátis pela fonte (AUD-I do Fiscal: "Frete grátis" e "Faltam R$ X" juntos se contradizem)
    linhaCarrinho.hidden = total === null || semOp || semLoggi || (gratisL && !chegou);
  }
  // L10g-2 (Riff): toda mudança do carrinho (cr:cart:updated e cr:cart:html do cart.js) avança a geração. A cotação em
  // curso confere a geração antes do POST e na resposta: se mudou, descarta e refaz com o carrinho novo (pela agenda).
  // Com resultado na tela, a mudança refaz a cotação: valor, nota e projeção ficam sempre da mesma base (v4: a cotação
  // da PDP é do carrinho com a peça). Nunca reaplica a seção antiga depois de um evento mais novo.
  // B4 da Palheta (L10k): uma mudança de carrinho chega como DOIS avisos (cr:cart:updated e, depois da seção, cr:cart:html):
  // a cotação em curso ou na tela é invalidada já (cancelar + "Calculando…") e refeita UMA vez: no cr:cart:html (o corpo
  // novo já existe) ou, sem ele, 1,5 s depois do cr:cart:updated. Antes eram 2 cotações por mudança (custo na Frenet).
  // Ordem real no cart.js: no drawer, html e updated no mesmo instante (html primeiro); na adição pela PDP, updated
  // primeiro e html depois da leitura da seção. O html sempre dispara já; o updated só agenda se nada estiver agendado.
  // L10k-2 (Riff): um html que chega depois da reserva de 1,5 s é da MESMA mudança já cotada pela reserva. A cotação
  // guarda a assinatura do carrinho que leu (linhas + totais da barra); html com a mesma assinatura é ignorado.
  let geracao = 0, base = null, cotada = null;
  const assinatura = (d) => (d?.querySelector?.('[data-cr-frete-itens]')?.textContent || '') + JSON.stringify(d?.querySelector?.('[data-cr-trio]')?.dataset || {});
  if (!carrinho) {
    for (const ev of ['cr:cart:updated', 'cr:cart:html']) {
      document.addEventListener(ev, (e) => {
        if (ev === 'cr:cart:html' && base !== null && assinatura(e.detail) === base) return;
        geracao += 1;
        if (!ultimo || (!ctl && !refaz && lista.hidden)) return;
        if (ev === 'cr:cart:updated' && refaz) return; // o html desta mudança já agendou
        cancelar(); limpar(); aviso(T.calculando);
        refaz = setTimeout(() => { refaz = null; calcular(ultimo, true); }, ev === 'cr:cart:html' ? 0 : 1500);
      });
    }
  }

  async function calcular(cep, recota) {
    const id = cancelar(); // (desfaz a recotação agendada: L10k-1)
    limpar();
    if (cep.length !== 8 || cep === '00000000') { campo.setAttribute('aria-invalid', 'true'); aviso(T.cepInvalido, true); return; }
    campo.removeAttribute('aria-invalid');
    // sem tamanho escolhido (a PDP abre sem pré-seleção), cota 1 peça com a 1ª variante com SKU (peso dela). Escolher o
    // tamanho depois refaz a cotação com o peso da variante escolhida (observador abaixo).
    const vid = varianteAtual();
    const v = variantes[vid] || Object.values(variantes).find((x) => x.sku);
    ultimaVariante = vid;
    const qtd = 1;
    // contrato v4 (decisão de Henrique, 17/10; hub/frete-proxy/CONTRATO.md): cada item com SKU (obrigatório), qtd, valor
    // por unidade em centavos e peso_g = peso real da variante em gramas (0 quando não cadastrado: o Hub usa a queda).
    // Drawer: os itens do carrinho. PDP: os itens do carrinho (lidos da seção do drawer, abaixo) + esta peça.
    let itens = carrinho ? dados.itens || [] : v ? [{ sku: v.sku, qtd, peso_g: v.peso_g || 0, valor: v.valor }] : [];
    if (!itens.length || itens.some((i) => !i.sku)) { aviso(T.erroFonte, true); return; }
    ultimo = cep;
    const minha = ++escolha;
    aviso(T.calculando);
    ctl = new AbortController();
    botao.disabled = true;
    let doc = null, prazo, chave = null;
    const g = geracao;
    try {
      // PDP (v4): itens do carrinho (JSON data-cr-frete-itens da barra) + esta peça; subtotal = valor declarado = total
      // EFETIVO pós-desconto (fórmula da Yampi, o mesmo da barra). Sem a seção (falha, 5 s sem resposta ou carrinho
      // vazio), só a peça, com a nota da peça. Drawer: o total que o Liquid já traz.
      // A seção é lida ANTES da vez na agenda: entre a marcação da vez e o POST não há espera.
      let subtotal = dados.total;
      if (!carrinho) {
        doc = await Promise.race([secao(ctl.signal).catch(() => null), new Promise((ok) => setTimeout(ok, 5000, null))]);
        if (id !== seq || !raiz.isConnected) return;
        base = doc ? assinatura(doc) : null;
        const doCarrinho = JSON.parse(doc?.querySelector('[data-cr-frete-itens]')?.textContent || '[]');
        // L10g-1 (Riff): linha sem SKU = o carrinho inteiro não pode ser cotado (o Hub recusaria). Falha fechada com a
        // F-08b, como o drawer: nunca cota o carrinho sem uma linha (peso omitido) nem promete o valor do pedido.
        // Linhas do carrinho sem os totais da barra (data-sub/data-fora) também: itens e subtotal teriam bases diferentes.
        const total = totalCom(doc, v, qtd);
        if (doCarrinho.some((i) => !i.sku) || (doCarrinho.length && total === null)) { aviso(T.erroFonte, true); return; }
        itens = [...doCarrinho, ...itens];
        subtotal = total ?? v.valor * qtd;
        // ajuste A do Gancho (L10g): com itens no carrinho a cotação é do carrinho com esta peça, e a nota diz isso
        if (notaP) notaP.textContent = doCarrinho.length ? T.notaCarrinho : T.nota;
        // L10k-2 (Riff): recotação pedida pelo carrinho com o MESMO carrinho, CEP e variante da última cotação → mostra a
        // resposta guardada, sem POST (vale mesmo quando o aviso do carrinho chega sem o corpo para comparar)
        chave = `${cep}|${v.sku}|${base}`;
        if (recota && cotada?.chave === chave) { mostrar(cotada.opcoes); if (doc) carrinhoMaisPeca(doc, v, qtd); return; }
      }
      // L10a-r4-1 (Riff): a vez é conferida de novo a cada despertar (timer atrasado, página suspensa): se outra consulta
      // enviou nesse meio-tempo, espera outra vez. Sem await entre a conferência e a marcação: um envio por vez.
      for (let t; (t = proxima - Date.now()) > 0;) {
        await new Promise((ok) => setTimeout(ok, t));
        if (id !== seq || !raiz.isConnected) return;
      }
      // L10g-2: o carrinho mudou durante a leitura da seção ou a espera → a base lida ficou velha. O aviso do carrinho já
      // cancelou esta consulta e agendou a nova (B4); aqui é só a trava: nada desta base vai ao Hub
      if (g !== geracao) return;
      proxima = Date.now() + intervalo;
      prazo = setTimeout(() => ctl?.abort(), 8000);
      const r = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, credentials: 'omit', signal: ctl.signal,
        body: JSON.stringify({ cep, itens, subtotal }) });
      const j = await r.json().catch(() => null);
      if (id !== seq || !raiz.isConnected) return;
      // L10g-2: o carrinho mudou durante o POST → resposta de um carrinho que não existe mais: descarta (a nova já está agendada)
      if (g !== geracao) return;
      if (r.ok && j && Array.isArray(j.opcoes)) {
        const opcoes = j.opcoes.filter((o) => o && Number.isInteger(o.valor) && o.valor >= 0);
        adic = j.prazo_adicional_dias;
        if (adic >>> 0 !== adic) adic = 1; // só inteiro >= 0 (sem o campo: 1)
        mostrar(opcoes);
        if (chave) cotada = { chave, opcoes };
        if (minha === escolha) try { sessionStorage.setItem(CHAVE, cep); } catch { /* sem armazenamento */ }
        // L10g-r3-1 (Riff): a projeção usa só a seção da própria cotação. Sem ela (falha ou 5 s), a cotação foi só da peça:
        // nada de projeção do carrinho (não relê a seção por fora, para não misturar a base do carrinho com a da peça)
        if (!carrinho && doc) carrinhoMaisPeca(doc, v, qtd);
      } else {
        // F-08 única (AUD-J, L10m; copy §5.5): uma situação, uma frase. 400 cep_invalido → CEP inválido; 429 → muitas;
        // 422 fora_da_faixa com mais de 50 peças → F-10; todo o resto (422 peso/dimensões/faixa, 502, 503, outros status,
        // rede, prazo de 8 s, JSON quebrado) → a genérica, sem "Tente de novo"
        const inv = j?.erro === 'cep_invalido';
        if (inv) campo.setAttribute('aria-invalid', 'true');
        aviso(inv ? T.cepInvalido : r.status === 429 ? T.muitas : j?.erro === 'fora_da_faixa' && itens.reduce((s, i) => s + i.qtd, 0) > 50 ? T.muitasPecas : T.erroFonte, !0);
      }
    } catch {
      if (id === seq) aviso(T.erroFonte, true);
    } finally {
      clearTimeout(prazo);
      if (id === seq) { ctl = null; botao.disabled = false; }
    }
  }

  campo.addEventListener('input', () => {
    const m = mascara(campo.value); if (m !== campo.value) campo.value = m;
    if (digitos(campo.value) !== ultimo) { cancelar(); limpar(); aviso(''); ultimo = ''; }
    campo.removeAttribute('aria-invalid');
  });
  // B4: "Calcular" com o MESMO CEP já cotado na tela, em curso ou agendado não cota de novo (o CEP lembrado já calculou ao
  // abrir; o clique repetido não gasta outra consulta). Depois de erro, ou com CEP novo, cota.
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const cep = digitos(campo.value);
    if (cep === ultimo && (ctl || refaz || !lista.hidden)) return;
    calcular(cep);
  });

  // troca de variante (peso e preço podem mudar): o product.js marca o rádio pelo atributo "checked" depois da SRA.
  // Seleção vazia (cor nova sem o tamanho, L5-1): invalida já o resultado e a consulta pendente; recalcula só quando
  // uma variante válida voltar.
  if (pdp) {
    new MutationObserver(() => {
      const vid = varianteAtual();
      if (vid === ultimaVariante) return;
      ultimaVariante = vid;
      if (!vid) { cancelar(); limpar(); aviso(''); return; }
      if (ultimo && digitos(campo.value) === ultimo) calcular(ultimo);
    }).observe(pdp, { subtree: true, attributes: true, attributeFilter: ['checked', 'value'], childList: true });
  }

  // CEP lembrado na sessão: preenche e calcula em tempo ocioso; desiste se o cliente já mexeu
  let salvo = '';
  try { salvo = digitos(sessionStorage.getItem(CHAVE)); } catch { /* sem armazenamento */ }
  if (salvo.length === 8 && !campo.value) {
    campo.value = mascara(salvo);
    const inicio = seq;
    const rodar = () => (window.requestIdleCallback || ((f) => setTimeout(f, 200)))(() => { if (seq === inicio && digitos(campo.value) === salvo) calcular(salvo); });
    if (document.readyState === 'complete') rodar(); else window.addEventListener('load', rodar, { once: true });
  }
}
